import axios from "axios"

const controller = "/puesto"

const PuestoService = {
    buscar: async (puesto) => {
        const { data } = await axios.post(`${controller}/buscar`, {
            puesto
        })
        return data
    },
    buscarRapido: async (puesto) => {
        const { data } = await axios.post(`${controller}/buscarRapido`, {
            puesto
        })
        return data
    },
}

export default PuestoService